import { render } from "./Ancestry.vue?vue&type=template&id=00fd719d&scoped=true"
import script from "./Ancestry.vue?vue&type=script&lang=js"
export * from "./Ancestry.vue?vue&type=script&lang=js"

import "./Ancestry.vue?vue&type=style&index=0&id=00fd719d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00fd719d"]])

export default __exports__